import React from 'react';
import { FormControl, Select, MenuItem, FormHelperText, Box, Typography } from '@mui/material';
import { Resource } from '../../types/resource';
import { useResources } from '../../hooks/resource/useResources';

interface ResourceSelectProps {
  selectedResources: string | null;
  onChange: (resourceIds: string | null) => void;
  availableResources?: Resource[];
  error?: boolean;
  helperText?: string;
}

const ResourceSelect: React.FC<ResourceSelectProps> = ({
  selectedResources,
  onChange,
  availableResources,
  error,
  helperText,
}) => {
  const { resources: allResources } = useResources();
  const resources = availableResources || allResources;

  return (
    <FormControl
      fullWidth
      error={error}
      size="small"
      sx={{
        '& .MuiInputBase-root': {
          height: 36,
        },
      }}
    >
      <Select
        value={selectedResources}
        onChange={e => onChange(e.target.value || null)}
        displayEmpty
        renderValue={selected =>
          selected ? resources.find(r => r.id.toString() === selected)?.name : 'Select Staff Member'
        }
        inputProps={{ 'aria-label': 'Without label' }}
      >
        {resources.map(resource => (
          <MenuItem key={resource.id} value={resource.id.toString()}>
            <Box sx={{ py: 1 }}>
              <Typography variant="body1">{resource.name}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default ResourceSelect;
